import React, { useCallback, useState } from 'react';
import { Box, CheckBox, HStack, IconButton, Text } from '@design-system/mobile';
import { UseFormRegister } from 'react-hook-form';
import { ConsultAgreeListItemDescription, QuickConsultInputs } from '@/types';
import TrackingService from '@/services/tracking';

interface ConsultAgreeListItemProps {
  id: number;
  title: string;
  description: ConsultAgreeListItemDescription[];
  name: 'agreement.privacy' | 'agreement.provide';
  checked: boolean;
  handleCheckBox: () => void;
  register: UseFormRegister<QuickConsultInputs>;
}

const ConsultAgreeListItem = ({
  id,
  title,
  description,
  name,
  checked,
  handleCheckBox,
  register,
}: ConsultAgreeListItemProps) => {
  const [isToggle, setIsToggle] = useState<boolean>(false);

  const handleToggle = useCallback(() => {
    setIsToggle(!isToggle);
  }, [isToggle]);

  return (
    <Box>
      <HStack py={10} width="100%" space="space-between">
        <HStack width="100%" style={{ flex: 1 }} onClick={handleCheckBox}>
          <CheckBox
            labelOptions={{
              text: title,
              textVariant: 'label_xlg_r',
            }}
            checked={checked}
            value={checked ? 'Y' : 'N'}
            onClick={handleCheckBox}
            {...TrackingService.tagGTM('consult_agree_button')}
          />
          &nbsp;
          <Text variant="label_xlg_r" color="color_chip.red.500">
            (필수)
          </Text>
        </HStack>
        <IconButton
          size="xs"
          onClick={handleToggle}
          variant={isToggle ? 'ic_arrow_up' : 'ic_arrow_down'}
          type="button"
        />
      </HStack>
      {isToggle && (
        <Box
          height={170}
          p={16}
          overflowY="scroll"
          backgroundColor="color_chip.gray.50"
          className="agree-description"
        >
          {description.map((item, idx) => {
            if (!item.isBold) {
              return (
                <Text variant="caption1" color="color_chip.gray.700" key={id}>
                  {item.text}
                </Text>
              );
            }
            return (
              <Text variant="subTitle2" color="color_chip.primary" key={id}>
                {item.text}
              </Text>
            );
          })}
        </Box>
      )}
      <input
        type="hidden"
        {...register(name, {
          required: {
            value: true,
            message: '약관에 동의해주세요',
          },
        })}
      />
    </Box>
  );
};

export default React.memo(ConsultAgreeListItem);
